import { styled } from '@material-ui/core/styles'

const FlexContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export { FlexContainer }
